// @flow
import createMaybeTransform from 'app/common/react/components/closeup/utils/createMaybeTransform';
import { toMaybeHasAttribution } from 'app/common/react/components/closeup/lib';
import type { HasPin, MaybeAToMaybeAB } from 'app/common/react/components/closeup/utils/types';

type HasEmbed = {
  embed: {
    src: string,
    subtype?: string,
    type?: string,
  },
};

type ToMaybeHasEmbed = MaybeAToMaybeAB<HasPin, HasEmbed>;

const hasEmbed: ToMaybeHasEmbed = createMaybeTransform((props) => {
  // Handle normal embed data
  const { embed } = props.pin,
    { type, src: embedSrc, subtype } = embed || {},
    // Handle Attribution Embeds as a fallback
    { attribution = {} } = toMaybeHasAttribution(props) || {},
    { embed: attributionEmbed = {} } = attribution,
    { src: attributionEmbedSrc } = attributionEmbed,
    // Source Url
    src = embedSrc || attributionEmbedSrc;
  return src
    ? {
        ...props,
        embed: { type, src, subtype },
      }
    : null;
});

export default hasEmbed;
